import React, { useRef, useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
const LineGraph = (props) => {
  const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );
    if (props.data) {
      //title
      var title = x.titles.create();
      title.text = props.title;
      title.fontSize = 20;
      title.fontWeight = 600;
      title.marginBottom = 30;
      title.fill = "lightgrey";

      // Create axes
      var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category
        ? props.category
        : "_id";
      categoryAxis.renderer.minGridDistance = 30;
      // categoryAxis.renderer.labels.template.rotation = 45;
      categoryAxis.renderer.labels.template.horizontalCenter = "left";
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.labels.template.rotation = props.rotation
        ? props.rotation
        : 0;
      categoryAxis.renderer.line.stroke = am4core.color("#000");

      var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 11;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");

      // Create series
      var series = x.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = props.lineOneValue;
      series.dataFields.categoryX = props.category;
      series.tooltipText = "{value}";
      series.strokeWidth = 3;
      series.name = props.legend1;
      series.minBulletDistance = 15;
      series.yAxis = valueAxis;
      series.stroke = props.lineOneColor
        ? am4core.color(props.lineOneColor)
        : "color";
      series.fill = props.lineOneColor
        ? am4core.color(props.lineOneColor)
        : "color";
      series.legendSettings.labelText = "[{stroke}]{name}[/]";

      // series.legendSettings.labelText = "HHHHHHH";

      // Create series
      var series2 = x.series.push(new am4charts.LineSeries());
      series2.dataFields.valueY = props.lineTwoValue;
      series2.dataFields.categoryX = props.category;
      series2.tooltipText = "{value}";
      series2.name =  props.legend2;
      series2.strokeWidth = 3;
      series2.yAxis = valueAxis;
      series2.minBulletDistance = 15;
      series2.stroke = props.lineTwoColor
        ? am4core.color(props.lineTwoColor)
        : "color";
      series2.fill = props.lineTwoColor
        ? am4core.color(props.lineTwoColor)
        : "color";
      series2.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Add legend
      x.legend = new am4charts.Legend();
      x.legend.fill = "#b1b0b5";

      // Make a panning cursor
      x.cursor = new am4charts.XYCursor();
      x.cursor.behavior = "panXY";
      x.cursor.xAxis = categoryAxis;
      x.cursor.snapToSeries = series;
      x.scrollbarX = new am4core.Scrollbar();
      x.scrollbarX.background.fill = am4core.color("#515151");
      x.scrollbarX.thumb.background.fill = am4core.color("#515151");
      x.scrollbarX.startGrip.background.fill = am4core.color("#515151");
      x.scrollbarX.endGrip.background.fill = am4core.color("#515151");
      x.scrollbarX.stroke = am4core.color("#515151");
      x.scrollbarX.thumb.background.states.getKey('hover').properties.fill = am4core.color("#515151");
      x.scrollbarX.background.strokeOpacity = 0;
      x.scrollbarX.thumb.background.strokeOpacity = 0;
      x.scrollbarX.startGrip.background.strokeOpacity = 0;
      x.scrollbarX.endGrip.background.strokeOpacity = 0;
      x.data = props.data;

      chart.current = x;
    }
    return () => {
      x.dispose();
    };
  }, []);

  return (
    <div className="App">
      <div
        id={props.divId ? props.divId : "DivID"}
        style={{
          width: "95%",
          height: "350px",
          padding: "10px",
          margin: "10px",
          boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
          borderRadius: "10px",
        }}
      ></div>
    </div>
  );
};

export default LineGraph;